import { Stripe, StripeElements } from '@stripe/stripe-js';
import { CreatePaymentMethodUsBankAccountData } from '@stripe/stripe-js/types/stripe-js/payment-intents';
import { useError } from 'hooks/useError';
import { useTranslation } from 'next-i18next';
import { useCallback, useState } from 'react';
import { addPaymentMethod } from 'utils/api';

import { AddPaymentMethodMutation, useAddPaymentMethodMutation } from '@/graphql/paymentMethods';
import { useGetSetupIntentQuery } from '@/graphql/setupIntent';

interface Props {
  onSuccess?: (paymentMethod: AddPaymentMethodMutation) => void;
}

export function useCreatePaymentMethod(props?: Props) {
  const { i18n } = useTranslation('common');
  const { language } = i18n;
  const { onSuccess } = props ?? {};
  const [loading, setLoading] = useState(false);
  const { reportError } = useError();
  const mutation = useAddPaymentMethodMutation();
  const { refetch } = useGetSetupIntentQuery(undefined, { enabled: false });

  const createPaymentMethod = useCallback(
    async (stripe: Stripe | null, elements: StripeElements | null, bank?: CreatePaymentMethodUsBankAccountData) => {
      setLoading(true);
      try {
        const paymentMethod = await addPaymentMethod(mutation, refetch, stripe, elements, bank, language);
        onSuccess && onSuccess(paymentMethod);
      } catch (e) {
        reportError('[useCreatePaymentMethod] createPaymentMethod', `Unable to create the payment method.`);
      } finally {
        setLoading(false);
      }
    },
    [language, mutation, onSuccess, refetch, reportError]
  );

  return {
    createPaymentMethod,
    loading,
  };
}
